import type { ComponentProps } from 'react';

type MeiaAutofillIgnoreProps = Pick<ComponentProps<'input'>, 'autoComplete'> & {
  'data-1p-ignore': 'true';
  'data-form-type': 'other';
  'data-lpignore': 'true';
};

export const MEIA_AUTOFILL_IGNORE_PROPS: MeiaAutofillIgnoreProps = {
  autoComplete: 'off',
  'data-1p-ignore': 'true',
  'data-form-type': 'other',
  'data-lpignore': 'true',
};
